/* Shopify enforces the offer; this only explains the selected product option. */
(() => {
  document.querySelectorAll('[data-figure-gift-note]').forEach(note => {
    let ids;
    try { ids = new Set(JSON.parse(note.dataset.eligibleIds).map(String)); } catch { return; }
    const section = note.closest('[data-product-section]');
    if (!section) return;
    const render = () => {
      const qualifies = ids.has(String(section.querySelector('[data-variant-id]')?.value));
      note.querySelector('[data-gift-eligible]').hidden = !qualifies;
      note.querySelector('[data-gift-excluded]').hidden = qualifies;
    };
    section.addEventListener('anivault:variant-change', render);
    render();
  });
})();
